/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-primary': {
    width: 6,
    height: 8,
    viewBox: '0 0 6 8',
    data: '<path pid="0" d="M.43 7.275v-.81l.33-.03c.194-.02.29-.114.29-.28v-4.65l-.57-.03v-.85h2.86c.747 0 1.329.175 1.745.525.417.35.625.875.625 1.575S5.474 3.97 5 4.36c-.473.39-1.1.585-1.88.585h-.85v1.45l.96.03v.85H.43zm1.84-3.3h.72c.974 0 1.46-.397 1.46-1.19 0-.48-.125-.799-.375-.955-.25-.157-.648-.235-1.195-.235h-.61v2.38z" fill-rule="nonzero"/>'
  }
})
